export const T = {
  en_GB: {
    headings: "Headings",
    fontSize: "Font size",
    weight: "Weight",
    colour: "Colour",
    default: "Default",
    defaultColour: "Default (text colour)",
    clear: "Clear",
    weightHelp: (font: string) =>
      `Only the weights ${font} actually has. The list changes with the font.`,
    weightAdjusted: (p: { font: string; from: string; to: string }) =>
      `${p.font} has no ${p.from}, so the heading weight is now ${p.to}.`,
    numberHeadings: "Number headings",
    numberHeadingsHelp: "Heading components are numbered 1, 2, 3 … in document order.",
  },
  nb_NO: {
    headings: "Overskrifter",
    fontSize: "Skriftstørrelse",
    weight: "Vekt",
    colour: "Farge",
    default: "Standard",
    defaultColour: "Standard (tekstfarge)",
    clear: "Fjern",
    weightHelp: (font: string) =>
      `Bare vektene ${font} faktisk har. Listen endres med skrifttypen.`,
    weightAdjusted: (p: { font: string; from: string; to: string }) =>
      `${p.font} har ikke ${p.from}, så overskriftsvekten er nå ${p.to}.`,
    numberHeadings: "Nummerer overskrifter",
    numberHeadingsHelp: "Overskriftskomponenter nummereres 1, 2, 3 … i dokumentets rekkefølge.",
  },
} as const;
